<div class="form-horizontal">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!showFormLoader) {
<div>
    <table class="table table-bordered form-inline enityDetails custom-table">
      <tr>
        @for (item of entityList; track $index) {
<td><span><strong>{{ item.key }}</strong></span></td>
}
      </tr>
      <tr>
        @for (item of entityList; track $index) {
<td><span>{{ item.value }}</span></td>
}
      </tr>
    </table>
    <h4>Part I</h4>
    @if (partIRows.length > 0) {
<table class="table table-bordered custom-table">
      <thead><tr><th>Description</th>@for (h of partIHeader; track $index) {
<th>{{ h.description || h.name || h.num }}</th>
}</tr></thead>
      <tbody>
        @for (row of partIRows; track $index) {
<tr>
          <td>{{ row.description || row.name }}</td>
          @for (key of row.attributeList; track $index) {
<td>{{ row.list?.[key] }}</td>
}
        </tr>
}
      </tbody>
    </table>
}
    <h4>Part II</h4>
    @if (partIIRows.length > 0) {
<table class="table table-bordered custom-table">
      <thead><tr><th>Description</th>@for (h of partIIHeader; track $index) {
<th>{{ h.description || h.name || h.num }}</th>
}</tr></thead>
      <tbody>
        @for (row of partIIRows; track $index) {
<tr>
          <td>{{ row.description || row.name }}</td>
          @for (key of row.attributeList; track $index) {
<td>{{ row.list?.[key] }}</td>
}
        </tr>
}
      </tbody>
    </table>
}
    <h4>Part III</h4>
    @if (partIIIRows.length > 0) {
<table class="table table-bordered custom-table">
      <thead><tr><th>Description</th>@for (h of partIIIHeader; track $index) {
<th>{{ h.description || h.name || h.num }}</th>
}</tr></thead>
      <tbody>
        @for (row of partIIIRows; track $index) {
<tr>
          <td>{{ row.description || row.name }}</td>
          @for (key of row.attributeList; track $index) {
<td>{{ row.list?.[key] }}</td>
}
        </tr>
}
      </tbody>
    </table>
}
  </div>
}
</div>
